export default "__VITE_ASSET__CGUgrTrp__"